/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { BREAKPOINTS, NEW_SIDEBAR_WIDTH } from '@src/styles/config';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { IconButton, MenuItem, Select } from '@mui/material';

export const StyledHeader = styled('div')`
  height: 65px;
  width: 100%;
  border-bottom: 1px solid ${COLOR.label['16']};
  box-sizing: border-box;
  padding: 8px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${COLOR.white};
  .icon-btn-tooltip-refer-and-get-reward {
    border-radius: 0;
    padding: 0;
    margin-bottom: 8px;
    margin-left: 16px;
    &:hover {
      background: transparent;
    }
    .zoom-image {
      animation: zoomInOut 1s infinite ease-in-out;
    }

    @keyframes zoomInOut {
      0% {
        transform: scale(1.1);
      }
      50% {
        transform: scale(1.05);
      }
      100% {
        transform: scale(1.1);
      }
    }
  }
  .container-header {
    display: flex;
    align-items: center;
    gap: 8px;
    .go-back-icon {
      color: ${COLOR.indigo.default};
    }
  }
  .container-user-info {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .container-btn {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .save-btn {
    height: 40px;
    cursor: pointer;
    background-color: ${COLOR.white};
    border: 1px solid ${COLOR.secondary['32']};
    border-radius: 12px;
    padding: 12px 16px;
    box-sizing: border-box;
    font-weight: 700;
    font-size: 16px;
    text-transform: none;
    &:disabled {
      pointer-events: all;
      cursor: not-allowed;
      opacity: 0.5;
      &:hover {
        background-color: ${COLOR.white};
        border: 1px solid ${COLOR.secondary['32']};
      }
    }
  }

  .icon-btn-tooltip {
    color: ${COLOR.white};
    background: linear-gradient(0deg, #ff3b30 0%, #ff6b00 100%);
    margin-left: 2px;
    border: 2px solid #ffd60a;
    border-radius: 50%;
    padding: 10px;
    position: relative;
  }

  .icon-container {
    position: relative;
  }

  .small-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${COLOR.primary};
  }
  .lable-create-new {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    color: ${COLOR.indigo.default};
  }
  .icon {
    color: ${COLOR.indigo.default} !important;
  }

  .circular-progress {
    color: ${COLOR.darkBlue};
  }

  .download-btn {
    /* The label is translated, so its width is not ours to fix: the widest
       translation decides. A floor keeps the button the size the header was
       drawn around whenever the label is narrower than that. */
    min-width: 138px;
    white-space: nowrap;
    height: 40px;
    cursor: pointer;
    background-color: ${COLOR.primary};
    border-radius: 12px;
    padding: 12px 16px;
    box-sizing: border-box;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.4px;
    vertical-align: middle;
    margin-left: auto;
    text-transform: none;
    color: ${COLOR.darkBlue};
    &:disabled {
      pointer-events: all;
      opacity: 0.5;
      background-color: ${COLOR.primary};
      cursor: not-allowed;
    }
  }

  .divider {
    width: 1px;
    height: 100%;
    background-color: #3c3c4329;
    margin: 0px 0px 0px 16px;
  }

  .wallet {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    .wallet-ads {
      width: ${`${NEW_SIDEBAR_WIDTH - 20}px`};
    }

    .wallet-character {
      display: flex;
      gap: 12px;
      align-items: center;
      width: 100%;

      .icon {
        padding: 10px;
        border-radius: 50%;
        background-color: ${COLOR.primary};
      }
    }

    .hover-wallet-package {
      border-radius: 8px;
      padding-left: 16px;
      padding-right: 16px;
      &:hover {
        background: rgba(30, 22, 78, 0.08);
        cursor: pointer;
      }
    }
  }

  .wallet-package {
    display: flex;
    flex-direction: column;
    text-align: right;
    gap: 4px;

    .characters-wrapper {
      display: flex;
      justify-content: flex-start;
      gap: 4px;
      align-items: center;
      float: right;
      margin-left: auto;
    }

    .lock-icon {
      color: ${COLOR.red};
      cursor: pointer;
    }

    .remain-characters {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: ${COLOR.darkBlue};
      display: flex;
      align-items: center;
      gap: 4px;
      float: right;
      margin-left: auto;
    }

    .expired-date {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.4px;
      color: ${COLOR.label[80]};
    }
  }
`;

export const StyledProjectTitle = styled('div')`
  max-width: ${(props) => `${props.maxWidth}px` || '450px'};
  height: ${(props) => (props.isNewHeaderUI ? '' : '40px')};
  display: block;
  box-sizing: border-box;
  min-width: 132px;

  @media (min-width: ${BREAKPOINTS.SM}px) {
    .input-wrapper {
      padding: 4px 8px;
    }
  }

  @media (max-width: ${BREAKPOINTS.SM}px) {
    .input-wrapper {
      padding: 0;
    }
  }
  .input-wrapper {
    border: ${(props) => (props.isNewHeaderUI ? 'none' : '1px solid white')};
    border-radius: 4px;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    padding: 4px 8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    height: 28px;

    &:hover {
      border: 1px solid ${COLOR.indigo[32]};
    }
    &:focus-within {
      border: 1px solid ${COLOR.primary};
    }
  }

  .size-span {
    white-space: pre;
    min-height: 1em;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;

    position: relative;
    opacity: 0;
    background: yellow;
    min-width: 2px;
    user-select: none;
    vertical-align: top;

    font-size: 16px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -0.4px;
    box-sizing: border-box;
  }

  .size-input {
    white-space: pre;
    position: absolute;
    top: 0;
    left: 0px;
    width: 100%;
    height: 100%;
    text-overflow: ellipsis;
    background: none;
    border: none;
    outline: none;
    color: inherit;

    font-size: 16px;
    color: #1c1c1e;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -0.4px;
    box-sizing: border-box;
  }

  .createdAt {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.4px;
    margin-left: 4px;
  }

  input::placeholder {
    font: inherit;
    color: ${COLOR.dark};
    opacity: 0.4;
  }
`;

export const StyledDownloadMenu = styled('div')`
  box-shadow: 0px 4px 16px 0px #00000029;
  border-radius: 16px;
  padding: 16px;
  width: 368px;
  .download-btn {
    background-color: ${COLOR.primary};
    border-radius: 12px;
    padding: 12px 16px;
    box-sizing: border-box;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.4px;
    width: 100%;
    vertical-align: middle;
    margin-left: auto;
    text-transform: none;
    color: ${COLOR.darkBlue};
    &:disabled {
      pointer-events: all;
      opacity: 0.5;
      background-color: ${COLOR.primary};
      cursor: not-allowed;
    }
  }
  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    align-items: center;
  }

  .label {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.4px;
    text-align: center;
    vertical-align: middle;
    color: #1c1c1e;
  }

  .animation-label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  /* Beta pill next to the label, matching the AI editor beta tag. */
  .animation-beta {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 480px;
    background: rgba(0, 122, 255, 0.08);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.4px;
    color: #007aff;
    white-space: nowrap;
  }

  .free-limit-note {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.64);
    margin-bottom: 8px;

    b {
      font-weight: 700;
    }

    .upgrade-link {
      color: ${COLOR.blueV2};
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .export-retention-note {
    font-style: italic;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.64);
    margin-bottom: 8px;

    b {
      font-weight: 700;
    }
  }

  .credit-consumption {
    display: block;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: ${COLOR.darkGray};
    margin-bottom: 8px;
  }

  .circular-progress {
    color: ${COLOR.darkBlue};
  }
`;

export const StyledSelect = styled(Select)`
  width: 220px;
  font-size: 14px;
  border-radius: 12px;
  padding: 8px 0px;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  vertical-align: middle;
  height: 40px !important;
  color: #1e164e;

  .MuiSelect-select {
    padding: 4px 8px !important;
    height: 40px !important;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
`;

export const PopoverButton = styled('div')`
  width: ${(props) => props.width || 'auto'};
  border: 1px solid #1e164e52;
  border-radius: 12px;
  .custom-button {
    width: fit-content;
    border-radius: 12px;
    padding: 4px 6px;
  }

  .title-button {
    padding-left: 4px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.4px;
    text-transform: none;
    color: ${COLOR.indigo[80]};
  }

  .arrow-icon {
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    color: ${COLOR.indigo[80]};
  }

  .toolbar-text {
    text-transform: lowercase;
  }
`;

export const PopoverMenuItem = styled(MenuItem)`
  padding: 8px 12px;
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;

  &.Mui-disabled {
    cursor: not-allowed;
    pointer-events: auto;
    opacity: 0.5;

    &:hover {
      background-color: transparent;
    }
  }
  color: ${(props) => props.active && COLOR.darkBlue};
  background-color: ${(props) => props.active && '#1E164E14'};
  display: flex;
  gap: 10px;

  &:hover {
    color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
    background-color: ${(props) =>
      props.active ? '#1E164E14' : TRANSPARENT_COLOR.dark};
  }
  .wrap-label {
    display: flex;
    gap: 10px;
    width: 100%;
    text-transform: none;
    align-items: center;
  }

  .text {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${COLOR.secondary[100]};
  }
  .button-img {
    width: 24px;
    height: 24px;
  }
`;

export const StyledHistoryButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  color: ${COLOR.indigo.default};
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};

  &.Mui-disabled {
    color: ${COLOR.indigo.default};
  }

  &:hover {
    background-color: ${COLOR.indigo[8]};
  }
`;

export const StyledSidebarTooltip = styled(
  ({ className, placement = 'right', ...props }) => (
    // eslint-disable-next-line react/jsx-filename-extension
    <Tooltip
      {...props}
      classes={{ popper: className }}
      arrow
      placement={placement}
    />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: COLOR.label[80],
    backdropFilter: 'blur(25px)',
    color: COLOR.white,
    borderRadius: '12px',
    fontSize: 14,
    fontWeight: 400,
    padding: '8px 16px',
    textAlign: 'center',
    maxWidth: 500,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: COLOR.label[80],
  },
}));

export const StyledPresentationFeedbackContent = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-direction: column;

  .description {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .note {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border: 0.5px solid ${COLOR.orangeV2[32]};
    border-radius: 12px;
    background-color: ${COLOR.orangeV2[8]};

    .img-containter {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }
`;
